<template>
  <div class="app-header">
    <div><nav-bar></nav-bar></div>
    <section class="hero is-fullheight header" style="min-height: calc(100vh - 80px); margin-top: -16px;">
      <!-- <div class="hero-head">
        <nav class="navbar">
          <div class="container widerContainer">
            <div class="navbar-brand">
              <router-link :to="'/' + $i18n.locale" class="navbar-item">
                <img src="../assets/images/logo_light.png" width="118px" heigth="94px" alt="hebo">
              </router-link>
              <div class="language-bar is-pulled-right">
                <button class="circle-button" v-bind:class="{ active: $i18n.locale=='en' }" @click="ChangeLocale('en')">EN</button> 
                <button class="circle-button" v-bind:class="{ active: $i18n.locale=='ro' }" @click="ChangeLocale('ro')">RO</button>
                <button class="circle-button" v-bind:class="{ active: $i18n.locale=='hu' }" @click="ChangeLocale('hu')">HU</button>
              </div>
            </div>
          </div>
        </nav>
      </div> -->
      <div class="hero-head" style="min-height: 142px;"></div>
      <div class="hero-body">
        <div class="container ">
          <div class="site-title">
            <h1 class="title animated bounceInDown has-text-info">
              {{ headerText.header1row }}
            </h1>
            <h2 class="subtitle animated bounceInLeft has-text-info">
              {{ headerText.header2row.first }} <span class="hebo"> {{ headerText.header2row.second }} </span> <span
                class="trailers"> {{ headerText.header2row.third }} </span> {{ headerText.header2row.fourth }} !
            </h2>
          </div>
          <h3 class="animated bounceInUp ">
            {{ headerText.header3row }}
          </h3>
        </div>
      </div>
      <div class="hero-foot is-vertical-center">
        <div class="container">
          <div class="columns">
            <div class="column is-1-tablet is-offset-1-fullhd ">
              <router-link :to="'/' + $i18n.locale" v-scroll-to="'#aboutus'" class="bouncing-ancor">
                <img class="animated infinite bounce slow" src="../assets/images/arrowdown.png" width="12px"
                  heigth="14px" alt="arrow">
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import '../../node_modules/animate.css/animate.min.css'
import Navbar from './Navbar.vue'
// import { watch } from 'fs';
export default {
  components: {
    'NavBar': Navbar
  },
  data() {
    return {

    }
  },
  computed: {
    headerText() {
      return this.$t("homePage")
    }
  },
  methods: {
    ChangeLocale(lang) {
      this.$i18n.locale = lang;
      this.$router.push(lang)
    }
  }
}
</script>

<style lang="scss">
.animated {
  animation-duration: 1.5s
}

.navbar .widerContainer {
  max-width: 1630px;
}

.widerContainer .navbar-item {
  padding: 20px 20px 20px 35px;
}

.title {
  font-size: 2.5rem;
}

.navbar-brand {
  padding: 0 10;
}

.header {
  background-image: url("../assets/images/background_front.png"), url("../assets/images/Hebo_cover_image.jpg");
  background-repeat: no-repeat;
  background-position: center, center;
  background-blend-mode: multiply;
  $background: $white-ter;

  @include mobile {
    background-position: right;
    background-image: url("../assets/images/Hebo_cover_image.png");
    background-color: #09404a;
  }

  background-size: cover;
}

.hero-body .container {
  max-width: 55%;
}

.bouncing-ancor {
  padding: 20px;
}

.hero-foot {
  min-height: 142px;
}

.app-header .hero-body h1 {
  color: #06171c;
  font-size: 3.4rem;
  opacity: 0.85;
}

.app-header .hero-body h2 {
  color: #06171c;
  font-size: 1.45rem;
  opacity: 0.85;
}

.app-header .hero-body h3 {
  color: #06171c;
}

.hero-body h2,
.hero-body h3 {
  color: #000;
}

.hero-foot .column {
  text-align: center;
  margin-bottom: 1rem;
  margin-left: 2.33%;
}

.hero-body .hebo {
  color: #cfdbd6;
  font-weight: 600;
}

.hero-body .trailers {
  color: #ef6d22;
  font-style: italic;
  font-weight: 600;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}

.menu:after {
  height: 7px;
  display: block;
  background: linear-gradient(to bottom, #e9e9e9, #fff);
  content: "";
  width: 100%;
}

.hero-body .container {
  max-width: 55%;
}

.hero-foot {
  min-height: 142px;
}

.navbar-item img {
  max-height: 6em !important;
}

.hero-body h1,
.hero-body h2,
.hero-body h3 {
  color: #000;
}

.hero-head .navbar {
  padding-top: 2rem;
}

.navbar {
  position: relative;
}

.language-bar {
  position: absolute;
  right: 0;
  top: 25%;
  padding-right: 20px;
}

.language-bar button:hover {
  cursor: pointer;
}

.hero-foot .column {
  text-align: center;
  margin-bottom: 1rem;
}

.hebo {
  color: #cfdbd6;
}

.trailers {
  color: #ef6d22;
  font-style: italic;
}

.is-vertical-center {
  display: flex;
  align-items: center;
}

.navbar .container {
  display: block;
}

@include mobile {
  .hero-body .container {
    max-width: 75%;
    margin: 0 auto;
    text-align: center;
  }

  .active {
    background: #37747f;
    color: #cfdbd6;
  }

}

@media only screen and (min-width: 1024px)and (max-width: 1025px) {
  .hero-foot {

    .container {
      position: absolute;
      top: 60%;
      left: 20%;
    }
  }

}

@media only screen and (max-width: 1170px) {
  .app-header .hero-body h1 {
    font-size: 2rem;
  }

  .app-header .hero-body h2 {
    font-size: 1rem;
  }

  .hero-body {
    padding-top: 1rem;
    padding-bottom: 1rem;

  }

  .hero-foot {
    min-height: 155px;

    .container {
      width: 50%;

      .column {
        min-width: 40px;
      }
    }
  }
}
</style>
